import { useCallback } from 'react';
import { Autocomplete, Chip, TextField } from '@mui/material';
import { TArgs } from '../../types/policies-types';
import DynamicArgsWrapper from '../../containers/ArgsWarpper/ArgsWrapper';
import { enablePoliciesSaveButton } from '../../actions/policies-selection-ui-actions/policies-selection-ui-actions';
import { updateProfilePolicyArgs } from '../../actions/policies-profile-actions/policy-state-actions';

const StringTagsArrayField: React.FC<
  React.PropsWithChildren<TArgs>
> = props => {
  const { name, label, policyId, tooltip } = props;
  const tags = props.value as string[];

  const handleDelete = useCallback(
    (removedTag: string): void => {
      const newtags = tags.filter(val => val !== removedTag);
      enablePoliciesSaveButton(true);
      updateProfilePolicyArgs({
        id: policyId,
        name,
        value: newtags,
      });
    },
    [name, policyId, tags],
  );

  return (
    <DynamicArgsWrapper meta={{ name, tooltip }} fullWidth={true}>
      <Autocomplete
        disableClearable={true}
        onChange={useCallback(
          (_event, value, reason) => {
            if (reason === 'createOption') {
              enablePoliciesSaveButton(true);
              updateProfilePolicyArgs({
                id: policyId,
                name,
                value: [...value],
              });
            }
          },
          [name, policyId],
        )}
        inputMode='text'
        size='small'
        sx={{
          minWidth: 218,
        }}
        value={tags}
        options={[]}
        renderTags={(value: readonly string[], getTagProps) =>
          value.map((option: string, index: number) => (
            <Chip
              size='small'
              variant='outlined'
              label={option}
              {...getTagProps({ index })}
              onDelete={() => handleDelete(tags[index])}
            />
          ))
        }
        renderInput={params => (
          <TextField
            {...params}
            variant='outlined'
            label={label}
            placeholder='Add...'
            size='small'
            inputProps={{
              ...params.inputProps,
              style: {
                minWidth: 100,
              },
            }}
          />
        )}
        freeSolo
        multiple
      />
    </DynamicArgsWrapper>
  );
};

export default StringTagsArrayField;
